<!--  eslint-disable vue/no-unused-vars -->
<template>
  <div>
    <v-row class="mx-4">
      <v-col cols="12" md="4">
        <h2 class="text-left">Staff Attendance Data</h2>
      </v-col>
      <v-col cols="12" md="4">
        <!-- get previous month btn -->
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              text
              @click="decrement"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </template>
          <span>Previous Month</span>
        </v-tooltip>

        <!-- month, year display -->
        <span class="primary--text mx-2"><b>{{ moment(current_month_year.month,"MM").format('MMMM') }}, {{ current_month_year.year }} </b></span>
        
        <!-- get next month btn -->
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="increment"
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              text
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </template>
          <span>Next Month</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" md="2" v-if="currentUser.privileges.canExportStaffAttendanceData">
        <download-excel
          :fetch="getExportData"
          :fields="export_fields"
          :name="getExportName()"
        >
          <v-btn
            class="text-right"
            :loading="export_in_progress"
            :disabled="export_in_progress"
            color="white"
            elevation="1"
            block
          >
            Export
            <v-icon right dark> mdi-export </v-icon>
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>mdi-cached</v-icon>
              </span>
            </template>
          </v-btn>
        </download-excel>
      </v-col>
    </v-row>

    <v-card class="ma-5">
      <v-row class=" mx-4  justify-center" justify="center">
        <v-col cols="12" md="6">
          <h3 class="text-left ">Attendance Sheet of Staff</h3>
        </v-col>
        <v-col cols="12" md="3" align-self="center">
          <div class="text-right"   >
      
          </div>
        </v-col>
        <v-col cols="12" md="3" class="mb-2 mt-0">
          <div class="text-right">
           
          </div>
        </v-col>
      </v-row>

      <v-data-table :headers="getDatatableHeaders()" :items="transformData()" :mobile-breakpoint='0' disable-pagination hide-default-footer>
         <template v-for="date_header in getDatatableHeaders()" v-slot:[`item.${date_header.value}`]= "{ item }">
            <div :key="date_header.value">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-if="(moment(new Date()).format('DD/MM/YYYY') == moment(date_header.value + '/' + current_month_year.month + '/' + current_month_year.year, 'DD/MM/YYYY').format('DD/MM/YYYY') 
                    && (item[date_header.value].status=='A' || item[date_header.value].status=='HD'))" 
                    class="black--text" color="rgba(0,0,0,0)">
                    ?
                  </span>
                  <span v-else :class="style_mapping[item[date_header.value] == '-' ? '-' : item[date_header.value].status].class" v-bind="attrs" v-on="on">
                    {{ item[date_header.value] == "-" ? "-" : item[date_header.value].status}}
                    <v-divider v-if="item[date_header.value] != '-' && item[date_header.value].notes" class="font-weight-bold black"></v-divider>
                  </span>
                </template>
                <span>{{ item[date_header.value].notes }}</span>
              </v-tooltip>
              <strong v-if="item[date_header.value].is_late" class="red--text">(L)</strong>

            </div>
        </template>
        <template v-slot:item.name="{item}">
          <!-- link to staff-specific page -->
          <router-link
            :to="{
              name: 'StaffAttendanceDetail',
              params: { staff_id: item.staff_id },
            }"
          >
          <h5> {{ item.name}}</h5>
          <h5 v-if="item.emp_id"> {{ '('+item.emp_id+')' }} </h5>
          </router-link>
        </template>
      </v-data-table>

      <!-- absent/present/invalid - table LEGENDS -->
      <div class="my-4">
        <v-row class="">
          <v-col
            cols="12"
            md="12"
            align="left"
            class="px-6 font-weight-medium"
          >
            <span class="success--text font-weight-bold"> P : Present </span>
            <span>│</span>
            <span class="success--text text--darken-2 font-weight-bold"> OT : Overtime </span>
            <span>│</span>
            <span class="red--text text--darken-3 font-weight-bold"> A : Absent </span>
            <span>│</span>
            <span class="blue--text font-weight-bold"> H : Holiday </span>
            <span>│</span>
            <span class="orange--text font-weight-bold"> PL : Paid Leave </span>
            <span>│</span>
            <span class="pink--text text--darken-1 font-weight-bold"> UL : Unpaid Leave </span>
            <span>│</span>
            <span class="yellow--text text--darken-1 font-weight-bold"> HD : Half Day </span>
            <span>│</span>
            <span class="purple--text text--darken-1 font-weight-bold"> W : Weekly Off </span>
            <span>│</span>
            <span class="red--text text--darken-1 font-weight-bold"> (L) : Late Mark </span>
            <span>│</span>
            <span class="font-weight-bold"> - : Invalid </span>
            <span>│</span>
            <span class="font-weight-bold"> _ : Notes Recorded </span>            
          </v-col>
        </v-row>
      </div>
    </v-card>    
    <!-- snackbar -->
    <v-snackbar v-model="snackbar.visible">
			{{ snackbar.text }}
			<template>
				<v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
			</template>
		</v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import api from "@api/index";
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
import JsonExcel from "vue-json-excel";
import TourHelper from "@utils/tour_helper";


export default {
  name: "StaffAttendanceData",
  components: {
    downloadExcel: JsonExcel
  },

  data() {
    return {
      moment: moment,
      classroom: {},

      snackbar: {
        visible: false,
        text: "",
      },
  
      current_month_year: { // store current month,year
        month: null,
        year: null,
      },

      attendanceData: [], // store attendance data here

      export_in_progress: false,
      export_fields: {
        "0" : "name",
      },
      style_mapping:{
        "A": {
          "class":"red--text text--darken-3 font-weight-bold",
        },
        "UL":{
          "class":"red--text text--darken-1 font-weight-bold",
        },
        "P":{
          "class":"success--text font-weight-bold",
        },
        "H":{
          "class":"blue--text font-weight-bold",
        },
        "PL":{
          "class": "orange--text font-weight-bold"
        },
        "HD":{
          "class":"yellow--text text--darken-1 font-weight-bold"
        },
        "OT": {
          "class": "success--text text--darken-2 font-weight-bold",
        },
        "W": {
          "class": "purple--text text--darken-1 font-weight-bold",
        },
        "-":{
          "color": "rgba(0,0,0,0)",
          "class": "black--text"
        },
      },
    }
  },
  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },
  methods:
  {
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Staff Attendance Details", description: "View individual staff's attendance for a month", videoLink: "https://youtube.com"});
        // steps.push({id: '2', description: "After Selecting classroom and date, click on fetch to take and edit attendance", el: '#fetch'});
        TourHelper.startTour(this, "staff__attendance__details", steps);
    },

    
    // go to next month
    increment(){
      var incremented_date = moment(this.current_month_year.year + "/" + this.current_month_year.month,"YYYY/MM").add(1, "months");
      this.current_month_year.month = Number(incremented_date.format('M'))
      this.current_month_year.year = incremented_date.year();
      this.getAllAttendanceRecords();
    },

    // go to prev month
    decrement() {
      var decremented_date = moment(this.current_month_year.year + "/" + this.current_month_year.month,"YYYY/MM").subtract(1, "months");
      this.current_month_year.month = Number(decremented_date.format('M'))
      this.current_month_year.year = decremented_date.year();
      this.getAllAttendanceRecords();
    },
    
    // get attendance records for the selected class, month, year
    async getAllAttendanceRecords() {
      var url = endpoints.getAllStaffAttendance + `?month=${this.current_month_year.month}&year=${this.current_month_year.year}`;
      this.attendanceData = await api.call(this.apiEssentials, url);
    },

    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },
    
    // create headers for export excel data
    async createExportHeaders(){
      // calculate no of days in particular year and month
      this.export_fields = {'0': 'name'};
      let num_days = new Date(this.current_month_year.year, this.current_month_year.month, 0).getDate();
      var dateHeader = {};
      var temp = {};
      for(var i = 1; i <= num_days; i++)
      {
        temp[i] = String(i); //data in {1:1,2:2,......} format
        Object.assign(dateHeader, temp); //temp properties to dateHeader 
      }
      Object.assign(this.export_fields, dateHeader);
    },

    // export data in excel format
    async getExportData() {
      this.createExportHeaders();
      this.export_in_progress = true; //loading and disabling the button  
      var res = this.transformData(); //storing output_list in res
      for(var i = 0; i < this.attendanceData.length; i++)
      { 
        if(this.attendanceData[i].employee_id) {
          res[i].name = res[i].name + ` (${this.attendanceData[i].employee_id})`
        }
      }

      // if status object present, set it to its status value
      res.forEach(data => {
        for(var i=1; i<=Object.keys(data).length; i++) {
          if(data[String(i)] instanceof Object) {
            data[String(i)] = data[String(i)].status
          }
        }
      })
      
      this.export_in_progress = false;
      return res;
    },

    // name of file to be exported
    getExportName() {
      return "Staff_Attendance_Details" + moment(this.current_month_year.month,"MM").format('MMM') + this.current_month_year.year
    },

    // display data-table headers
    getDatatableHeaders(){
      let headers= [ // header names
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name",
          width: 170  
        },
      ];
      let days = [];
      let num_days = new Date(this.current_month_year.year, this.current_month_year.month, 0).getDate();
      for(let i=1;i<= num_days;i++) {
        days.push({
          text: String(i) + ' ' + moment(new Date(this.current_month_year.year,this.current_month_year.month-1,i)).format('ddd'),
          align: "center",
          sortable: false,
          value: String(i),
        })
      }
      return headers.concat(days);
    },

    // transform api response for data-table items
    transformData() {
      var output_list = [];   // output list to store attendance data.
        this.attendanceData.forEach(data => {   // traverse attendance data to find and set status
          var day_attendance_obj = {}
          day_attendance_obj['name'] = data.full_name;// set name
          day_attendance_obj['emp_id'] = data.employee_id;
          day_attendance_obj['staff_id'] = data.id  // set staff id
          let num_days = new Date(this.current_month_year.year, this.current_month_year.month, 0).getDate();  // get no. of days in current month,year
          for (let i = 1; i<= num_days; i++) {
            let lecture = data.attendance.find((lec) => lec.day == i);  // check if there is attendance data for that day
            if(lecture) { // if data is found, set status
              day_attendance_obj[String(i)] = {
                "status" : lecture.status,
                "notes" : lecture.notes,
                "is_late" : lecture.is_late,
              }
            }
            else{   // if data is not found i.e. invalid
              day_attendance_obj[String(i)] = '-';
            }
          }
          // prepare the output list
          output_list.push(day_attendance_obj)
      })
      return output_list;
    },
  },

  created() {
      // set current month,year
      this.current_month_year.month = new Date().getMonth() + 1
      this.current_month_year.year = new Date().getFullYear()
      this.headers = this.getDatatableHeaders();
      // display attendance records
      this.getAllAttendanceRecords();
      this.handleTour();
  }, 
}
</script>

<style scoped>
.data {
  text-align: start;
  vertical-align: middle;
}

.headers {
  text-align: start;
  font-weight: bolder;

  color: #000000;
  vertical-align: middle;
}
</style>
